import { Navbar, Footer } from '@/components/marketing';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      
      <section className="pt-32 pb-20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-4xl font-bold mb-8">Terms of Service</h1>
            <p className="text-muted-foreground mb-8">Last updated: December 2024</p>

            <div className="prose prose-gray dark:prose-invert max-w-none">
              <h2 className="text-2xl font-bold mt-8 mb-4">1. Acceptance of Terms</h2>
              <p className="text-muted-foreground mb-4">
                By accessing and using SparkCommerce, you accept and agree to be bound by the terms 
                and provision of this agreement. If you do not agree to abide by these terms, 
                please do not use this service.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">2. Description of Service</h2>
              <p className="text-muted-foreground mb-4">
                SparkCommerce provides a WhatsApp commerce platform that enables businesses to 
                manage customer conversations, process orders, manage inventory, and generate invoices.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">3. User Obligations</h2>
              <p className="text-muted-foreground mb-4">
                You agree to use SparkCommerce only for lawful purposes and in accordance with 
                WhatsApp's Business Policy and Commerce Policy. You are responsible for all 
                activity that occurs under your account.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">4. Payment Terms</h2>
              <p className="text-muted-foreground mb-4">
                Paid plans are billed monthly or annually in advance. Prices are subject to 
                change with 30 days notice. Refunds are provided in accordance with our 
                refund policy.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">5. Intellectual Property</h2>
              <p className="text-muted-foreground mb-4">
                The SparkCommerce platform, including all content, features, and functionality, 
                is owned by SparkCommerce and is protected by international copyright, trademark, 
                and other intellectual property laws.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">6. Limitation of Liability</h2>
              <p className="text-muted-foreground mb-4">
                SparkCommerce shall not be liable for any indirect, incidental, special, 
                consequential, or punitive damages resulting from your use of the service.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">7. Contact Information</h2>
              <p className="text-muted-foreground mb-4">
                For any questions regarding these terms, please contact us at legal@VirtualSpark info tech.com
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
